import { MAX_CONSENT_FORM_FILE_BYTES, MAX_CONSENT_FORM_VALIDITY_MONTHS } from '../../constants/ConsentForms';

const isPdfFile = (file) => (
  Boolean(file)
  && (file.type === 'application/pdf' || /\.pdf$/i.test(file.name || ''))
);

/** The i18n key describing why a chosen file cannot be uploaded, or null. */
export const validateConsentFormFile = (file) => {
  if (!file) {
    return 'consentForms.management.validation.fileRequired';
  }

  if (!isPdfFile(file)) {
    return 'consentForms.management.validation.fileType';
  }

  if (file.size > MAX_CONSENT_FORM_FILE_BYTES) {
    return 'consentForms.management.validation.fileSize';
  }

  return null;
};

export const validateConsentForm = (formData, languages, { requireFile = false } = {}) => {
  const errors = {};

  if ((languages || []).some((language) => !String(formData?.name?.[language] || '').trim())) {
    errors.name = 'consentForms.management.validation.nameRequired';
  }

  const rawValidity = formData?.validityMonths;
  if (rawValidity !== '' && rawValidity != null) {
    const months = Number(rawValidity);
    if (!Number.isInteger(months) || months < 1 || months > MAX_CONSENT_FORM_VALIDITY_MONTHS) {
      errors.validityMonths = 'consentForms.management.validation.validityInvalid';
    }
  }

  if (requireFile) {
    const fileError = validateConsentFormFile(formData?.file);
    if (fileError) {
      errors.file = fileError;
    }
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};
